import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { OverlayPanel } from "primereact/overlaypanel";
import { Tooltip } from "primereact/tooltip";
import DatePicker from "react-datepicker";
import { FaSearch, FaCloudDownloadAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";

import api from "../service/ApiService";
import { AllData } from "../service/AllData";
import ErrorDialog from "../components/ErrorDialog";
import SuccessDialog from "../components/SuccessDialog";
import Loader from "../components/Loader";
import {
  getGroupListUrl,
  getDeviceSearchData,
  getCreationDateWiseDevoices,
  getGeofenceAlertsReport,
  baseUrl,
} from "../service/ApiUrls";

import "react-datepicker/dist/react-datepicker.css";
import "react-confirm-alert/src/react-confirm-alert.css";

const helpIcon = require("../assets/icons/help_icon.png");
const FileDownload = require("js-file-download");

export class EnrollmentHistory extends Component {
  constructor(props) {
    super(props);
    let currentDate = new Date();
    this.state = {
      group: null,
      profileList: [],
      groupList: [],
      selectedProfile: null,
      selectedgroup: null,
      content: [],
      totalRecords: 0,
      startDate: new Date(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000),
      endDate: currentDate,
      errorMessage: "Something went wrong!",
      isLoading: false,
      isError: false,
      isSuccess: false,
      visible: false,
      prechecked: false,
      rowData: null,
      dfirst: 0,
      drows: 20,
    };
    this.alldata = new AllData();
    this.stockBodyTemplate = this.stockBodyTemplate.bind(this);
  }

  componentDidMount() {
    this.callDeviceSearchData();
  }

  onDialogueHide = () => {
    this.setState({ isError: false });
  };

  onDialogueHideSuccess = () => {
    this.setState({ isSuccess: false });
  };

  dateConvert = (date) => {
    if (!date) return "";
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return String("00" + day).slice(-2) + "-" + String("00" + month).slice(-2) + "-" + year;
  };

  convertDate = (date) => {
    if (!date) return "";
    var today = new Date(date);
    return today.toLocaleDateString("en-GB");
  };

  // When filters change, update state and reset page window back to page 1
  handleProfileChange = (e) => {
    let profileObject = this.state.profileList.find((obj) => obj.id === e.target.value);
    this.setState({ selectedProfile: profileObject || null, dfirst: 0 }, () => {
      this.callEnrollmentConfigList({ first: 0 });
    });
  };

  handleGroupChange = (e) => {
    let groupObject = this.state.groupList.find((obj) => obj.id === e.target.value);
    this.setState({ selectedgroup: groupObject || null, dfirst: 0 }, () => {
      this.callEnrollmentConfigList({ first: 0 });
    });
  };

  startChange = (date) => {
    this.setState({ startDate: date, dfirst: 0 }, () => {
      this.callEnrollmentConfigList({ first: 0 });
    });
  };

  endChange = (date) => {
    this.setState({ endDate: date, dfirst: 0 }, () => {
      this.callEnrollmentConfigList({ first: 0 });
    });
  };

  stockBodyTemplate(rowData) {
    return <>{rowData.enrollmentDate === null ? "N/A" : rowData.enrollmentDate}</>;
  }
  callEnrollmentConfigList = (options = {}) => {
    // If a manual 'first' isn't passed, calculate page index from state: (dfirst / drows)
    const first = options.first !== undefined ? options.first : (this.state.dfirst / this.state.drows);
    const limit = options.limit !== undefined ? options.limit : this.state.drows;

    const start = options.start || this.dateConvert(this.state.startDate);
    const end = options.end || this.dateConvert(this.state.endDate);

    const profileid = options.profileid !== undefined ? options.profileid :
      (this.state.selectedProfile ? this.state.selectedProfile.id : null);

    const groupid = options.groupid !== undefined ? options.groupid :
      (this.state.selectedgroup ? this.state.selectedgroup.id : null);

    this.setState({ isLoading: true }, () => {
      api
        .get(baseUrl + "/enrollment-config-list/enrolled-device-list", {
          params: { first, limit, start, end, profileid, groupid },
        })
        .then((res) => {
          if (res.data && res.data.result.isError === false) {
            this.setState({
              content: res.data.data.content || [],
              totalRecords: res.data.data.totalRecords || 0,
              isLoading: false,
            });
          } else {
            this.setState({ isLoading: false });
            confirmAlert({
              title: "Error Message",
              message: <p className="mod-p"> {res.data.result.errorMsg} </p>,
              buttons: [
                {
                  label: "Ok",
                  onClick: () => this.callEnrollmentConfigList(),
                },
              ],
            });
          }
        })
        .catch(() => {
          this.setState({ isLoading: false, isError: true });
        });
    });
  };

  callCrationDateWiseDevices = ({ geoAlertOrCreationDevice, start, end, profileid, groupid }) => {
    api
      .get(geoAlertOrCreationDevice === true ? getCreationDateWiseDevoices : getGeofenceAlertsReport, {
        responseType: "blob",
        params: { start, end, profileid, groupid },
      })
      .then((res) => {
        const fileName = res.headers["content-disposition"].split("filename=")[1];
        FileDownload(res.data, fileName);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  callDeviceSearchData = () => {
    api
      .get(getDeviceSearchData)
      .then((res) => {
        if (res.data.result.isError === false) {
          this.setState(
            {
              profileList: res.data.data.profileList || [],
              groupList: res.data.data.groupList || [],
            },
            () => {
              this.callEnrollmentConfigList();
            }
          );
        } else if (res.data.result.isError) {
          this.setState({
            isError: true,
            errorMessage: res.data.result.errorMsg,
          });
        }
      })
      .catch(() => {
        localStorage.setItem("loggedIn", "false");
      });
  };

  callGroupList = ({ first = 0, limit = 10, filter, profileId } = {}) => {
    api
      .get(getGroupListUrl, { params: { first, limit, filter, profileId } })
      .then((res) => {
        if (res.data.result.isError === false) {
          this.setState({
            ...res.data.data,
            group: res.data.data.content,
          });
        } else if (res.data.result.isError) {
          this.setState({
            isError: true,
            errorMessage: res.data.result.errorMsg,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  callDeleteGroupApi = ({ id, rowData }) => {
    api
      .delete(getGroupListUrl + "/" + id)
      .then((res) => {
        if (res.data.result.isError === false) {
          var array = [...this.state.group];
          var index = array.indexOf(rowData);
          if (index !== -1) {
            array.splice(index, 1);
            this.setState({ group: array, isSuccess: true });
          }
        } else if (res.data.result.isError) {
          this.setState({
            isError: true,
            errorMessage: res.data.result.errorMsg,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  rowDelete = (rowData) => {
    if (rowData && rowData.id) {
      this.callDeleteGroupApi({ id: rowData.id, rowData });
    }
  };

  onPage = (event) => {
    // Calculate the page index (e.g., if first=10 and rows=10, page index is 1)
    const pageIndex = event.first / event.rows;

    this.setState(
      {
        dfirst: event.first, // Keep this for PrimeReact UI state tracking
        drows: event.rows,   // Update rows per page if changed
      },
      () => {
        // Send the calculated page index and rows to your API
        this.callEnrollmentConfigList({
          first: pageIndex,
          limit: event.rows,
        });
      }
    );
  };

  render() {
    const items = [
      { label: "Dashboard", url: "dashboard" },
      { label: "Enroll", url: "enroll" },
      { label: "Enrollment History" },
    ];

    const profileOptions = this.state.profileList.map((e, i) => (
      <option key={i} value={e.id}>{e.name}</option>
    ));

    const groupOptions = this.state.groupList.map((e, i) => (
      <option key={i} value={e.id}>{e.name}</option>
    ));

    const header = (
      <div id="cus-p" className="row justify-content-start">
        <div className="p-col-12 p-md-2 p-lg-2">
          <h2 style={{ textAlign: "left", padding: "28px 0px" }}>Enroll Devices</h2>
        </div>

        {/* Profile Dropdown */}
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="form-group" style={{ textAlign: "left" }}>
            <label>Profile</label>
            <select
              className="form-control"
              onChange={this.handleProfileChange}
              id="selectedProfile"
              name="selectedProfile"
              value={this.state.selectedProfile ? this.state.selectedProfile.id : ""}
            >
              <option value="">Select Profile</option>
              {profileOptions}
            </select>
          </div>
        </div>

        {/* Group Dropdown */}
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="form-group" style={{ textAlign: "left" }}>
            <label>Group</label>
            <select
              className="form-control"
              onChange={this.handleGroupChange}
              id="selectedgroup"
              name="selectedgroup"
              value={this.state.selectedgroup ? this.state.selectedgroup.id : ""}
            >
              <option value="">Select Group</option>
              {groupOptions}
            </select>
          </div>
        </div>

        {/* Start Date */}
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="form-group" style={{ textAlign: "left" }}>
            <label>Start Date</label>
            <DatePicker
              selected={this.state.startDate}
              onChange={this.startChange}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              isClearable
              className="date-class p-col-12 p-md-12 p-xl-12"
              dateFormat="dd-MM-yyyy"
              placeholderText="Select Start Date"
            />
          </div>
        </div>

        {/* End Date */}
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="form-group" style={{ textAlign: "left" }}>
            <label>End Date</label>
            <DatePicker
              selected={this.state.endDate}
              onChange={this.endChange}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              minDate={this.state.startDate}
              isClearable
              className="date-class p-col-12 p-md-12 p-xl-12"
              dateFormat="dd-MM-yyyy"
              placeholderText="Select End Date"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p-col-12 p-md-2 p-lg-2">
          <div className="c-p" style={{ paddingTop: "24px" }}>
            <button
              className="btn btn-primary5"
              style={{ float: "left", marginRight: "5px" }}
              onClick={() => this.callEnrollmentConfigList({ first: this.state.dfirst })}
            >
              <FaSearch />
            </button>
            <Tooltip target=".export" position="top" mouseTrack mouseTrackTop={20} />
            <button
              className="btn btn-primary5 export"
              style={{ float: "left" }}
              data-pr-tooltip="Export"
              disabled={this.state.totalRecords === 0}
              onClick={() => {
                this.callCrationDateWiseDevices({
                  geoAlertOrCreationDevice: true,
                  start: this.dateConvert(this.state.startDate),
                  end: this.dateConvert(this.state.endDate),
                  profileid: this.state.selectedProfile ? this.state.selectedProfile.id : null,
                  groupid: this.state.selectedgroup ? this.state.selectedgroup.id : null,
                });
              }}
            >
              <FaCloudDownloadAlt />
            </button>
          </div>
        </div>
      </div>
    );

    const footer = (
      <div>
        <Button
          label="Yes"
          icon="pi pi-check"
          className="p-button-success"
          onClick={() => {
            this.setState({ visible: false, isLoading: true });
            this.rowDelete(this.state.rowData);
          }}
        />
        <Button
          label="No"
          icon="pi pi-times"
          className="p-button-danger"
          onClick={() => {
            this.setState({ visible: false });
          }}
        />
      </div>
    );

    const deleteDialogue = (
      <Dialog
        header="Delete Device Group"
        visible={this.state.visible}
        style={{ width: "35vw" }}
        modal={true}
        footer={footer}
        onHide={() => this.setState({ visible: false })}
      >
        <p style={{ textAlign: "center" }}>
          <span style={{ fontWeight: "bold", display: "block", paddingBottom: "10px", marginBottom: "10px" }}>
            All the group members will be shifted to profile.
          </span>
          <span className="form-check" style={{ display: "block" }}>
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
              checked={this.state.prechecked}
              onChange={(e) => {
                this.setState({ prechecked: e.target.checked });
              }}
            />
            <label className="form-check-label" htmlFor="exampleCheck1">
              Preserve the group's apps and manage those device-wise
            </label>
          </span>
        </p>
      </Dialog>
    );

    const home = { icon: "pi pi-home", url: "dashboard" };

    return (
      <div className="p-col-12 p-grid">
        <div className="p-col-12 p-lg-12 p-ll">
          <div className="p-col-9 inline-b p-ll">
            <BreadCrumb model={items} home={home} />
          </div>
          <div className="p-col-3 inline-b p-zz">
            <img
              src={helpIcon}
              alt="help"
              width="20"
              height="20"
              onClick={(e) => this.op.toggle(e)}
              style={{ marginBottom: "-10px", float: "right", cursor: "pointer" }}
            />
          </div>
          <OverlayPanel ref={(el) => (this.op = el)} id="overlay_panel" showCloseIcon={true}>
            <div className="col" style={{ width: "fit-content", maxWidth: "300px", padding: "0px" }}>
              <div className="helptip-title"><b>How to : Enrollment History</b></div>
              <div className="helptip-des">
                Users have option to manage devices by group rather than
                individual. One device belongs to only one group and each group
                must have a device profile. Once devices are bound to a group,
                the device profile of that group are automatically applied on
                those devices.
              </div>
            </div>
          </OverlayPanel>
        </div>

        {deleteDialogue}

        {/* Loader Dialog */}
        <Dialog visible={this.state.isLoading} modal closable={false} showHeader={false} style={{ width: "20vw" }} onHide={this.onDialogueHide}>
          <Loader />
        </Dialog>

        {/* Success Dialog */}
        <Dialog visible={this.state.isSuccess} modal style={{ width: "25vw" }} closable showHeader onHide={this.onDialogueHideSuccess}>
          <SuccessDialog successMessage="Deleted Group Successfully" />
        </Dialog>

        {/* Data Table Wrapper */}
        <div className="p-grid bg-col p-lg-12">
          <div className="p-col">
            <div className="datatable-paginator-demo">
              <DataTable
                value={this.state.content}
                style={{ marginBottom: "20px" }}
                responsive={true}
                header={header}
                emptyMessage="No records found"
                paginator
                lazy
                totalRecords={this.state.totalRecords}
                onPage={this.onPage}
                first={this.state.dfirst}
                rows={this.state.drows}
                rowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              >
                <Column field="imei1" header="IMEI 1" style={{ width: "20%" }} />
                <Column field="imei2" header="IMEI 2" style={{ width: "15%" }} />
                <Column field="enrollmentDate" header="Date of Enrollment" body={this.stockBodyTemplate} />
                <Column field="enrollmentStatusSt" header="Enrollment Status" />
                <Column field="profileName" header="Profile" />
                <Column field="statusSt" header="Status" />
              </DataTable>
            </div>

            {/* Error Dialog */}
            <Dialog visible={this.state.isError} modal style={{ width: "20vw" }} closable showHeader onHide={this.onDialogueHide}>
              <ErrorDialog errorMessage={this.state.errorMessage} />
            </Dialog>
          </div>
        </div>
      </div>
    );
  }
}